module.exports = __webpack_public_path__ + "img/roadmap-phase-2-cell-4-icon.b13b81c9.svg";